import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'

import { AppState } from '../reducers'

import de from '../translations/de.json'
import nl from '../translations/nl.json'
import en from '../translations/en.json'

const messages = {
	de: de as Record<string, string>,
	nl: nl as Record<string, string>,
	en: en as Record<string, string>,
}

const mapStateToProps = (state: AppState) => ({
	locale: state.ui.locale,
	messages: messages[state.ui.locale as keyof typeof messages],
})

const WrappedIntlProvider = connect(mapStateToProps)(IntlProvider)

export default WrappedIntlProvider
